import React from 'react';
import PasswordProtected from './PasswordProtected';
import QuoteGenerator from './QuoteGenerator';

const QuoteGeneratorPage: React.FC = () => {
  return (
    <PasswordProtected>
      <QuoteGenerator />
    </PasswordProtected>
  );
};

export default QuoteGeneratorPage;
